"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Event = exports.SOURCE_DOMAIN = exports.SERVICE_DIRECTORY_DEFAULT_FILTER = exports.SERVICE_DIRECTORY_DEFAULT_NAME = void 0;
exports.SERVICE_DIRECTORY_DEFAULT_NAME = '0';
exports.SERVICE_DIRECTORY_DEFAULT_FILTER = 3;
exports.SOURCE_DOMAIN = 'Source';
const Add = 'Add';
const Delete = 'Delete';
const Update = 'Update';
const Status = 'Status';
const Complete = 'Complete';
const Error = 'error';
exports.Event = { Add, Delete, Update, Status, Complete, Error };
